import { memo, useCallback, useMemo } from 'react';
import { Pressable } from 'react-native';
import { CategoryProps } from './../Category.types';
import { State, useSelector } from '@bonanza-social/toolkit/state';
import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { selectCategory } from '../../../../state/categories/categories.slice';
import {
  DEFAULT_CATEGORY_STYLE_CONFIG,
  JACKPOT_CATEGORY_STYLE_CONFIG,
} from '../../Categories.content';
import Games from '../../../Games/Games';
import { getReducedGameIds } from '../Category.utils';

function DefaultCategory({ categoryId, ...rest }: CategoryProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const category = useSelector((state: State) =>
    selectCategory(state, categoryId),
  );
  const reducedGameIds = useMemo(
    () => getReducedGameIds(category?.games),
    [category?.games],
  );

  const onCategoryPress = useCallback(() => {
    navigation.navigate('CategoryDetailsScreen', { id: categoryId });
  }, [categoryId, navigation]);

  if (!category || !category.games.length) {
    return null;
  }

  const isJackpot = category.theme.name === 'Jackpot';

  return (
    <Box
      gap="space-200"
      {...(isJackpot && JACKPOT_CATEGORY_STYLE_CONFIG.box)}
      {...rest}
    >
      <Pressable onPress={onCategoryPress}>
        <Box
          gap="space-100"
          alignItems="center"
          flexDirection="row"
          paddingHorizontal="space-400"
        >
          <Text
            variant="h6"
            {...(isJackpot
              ? JACKPOT_CATEGORY_STYLE_CONFIG.text
              : DEFAULT_CATEGORY_STYLE_CONFIG)}
          >
            {category.title}
          </Text>
          <Icon
            gradient="accentBackground"
            name="arrowForwardIosOutlined"
            width="space-400"
            height="space-400"
          />
        </Box>
      </Pressable>
      <Box flex={1}>
        <Games ids={reducedGameIds} imageType={category.imageType.name} />
      </Box>
    </Box>
  );
}

export default memo(DefaultCategory);
